import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import UserItemInfoToken from './UserItemInfoToken';
export default function ItemInfoToken(_a) {
    var prefix = _a.prefix;
    var intl = useIntl();
    var options = useMemo(function () {
        var attributeOptions = [
            {
                labelId: 'ui-plugin-bursar-export.bursarExports.token.itemInfo.name',
                value: 'NAME',
            },
            {
                labelId: 'ui-plugin-bursar-export.bursarExports.token.itemInfo.barcode',
                value: 'BARCODE',
            },
            {
                labelId: 'ui-plugin-bursar-export.bursarExports.token.itemInfo.material',
                value: 'MATERIAL_TYPE',
            },
            {
                labelId: 'ui-plugin-bursar-export.bursarExports.token.itemInfo.instId',
                value: 'INSTITUTION_ID',
            },
            {
                labelId: 'ui-plugin-bursar-export.bursarExports.token.itemInfo.campId',
                value: 'CAMPUS_ID',
            },
            {
                labelId: 'ui-plugin-bursar-export.bursarExports.token.itemInfo.libId',
                value: 'LIBRARY_ID',
            },
            {
                labelId: 'ui-plugin-bursar-export.bursarExports.token.itemInfo.locId',
                value: 'LOCATION_ID',
            },
        ];
        return attributeOptions
            .map(function (option) { return ({
            label: intl.formatMessage({ id: option.labelId }),
            value: option.value,
        }); })
            .sort(function (a, b) { return a.label.localeCompare(b.label); });
    }, [intl]);
    return (React.createElement(UserItemInfoToken, { prefix: prefix, defaultValue: "NAME", attributeName: "itemAttribute", options: options }));
}
